import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function IzvorIcon(props: SvgIconProps) {
  return <SvgIcon {...props} >
    <svg version="1.1" id="IzvorIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="#FFFFFF" d="M70.5,50c0-11.3-9.2-20.5-20.5-20.5S29.5,38.7,29.5,50c0,9.1,5.9,16.8,14.2,19.5v3.3L33.5,83l9,9l13.9-13.9
	v-8.6C64.6,66.8,70.5,59.1,70.5,50z"/>
      <path fill="#3CAA78" d="M66.7,50c0-9.2-7.5-16.7-16.7-16.7S33.3,40.8,33.3,50c0,8.4,6.1,15.3,14.2,16.5v7.9L38.8,83l3.6,3.6
	l10.1-10.1v-10C60.6,65.3,66.7,58.4,66.7,50z"/>
    </svg>
  </SvgIcon>
}

export default IzvorIcon;
